import { render, staticRenderFns } from "./VueInputTag.vue?vue&type=template&id=00d27606&scoped=true"
import script from "./VueInputTag.vue?vue&type=script&lang=js"
export * from "./VueInputTag.vue?vue&type=script&lang=js"
import style0 from "./VueInputTag.vue?vue&type=style&index=0&id=00d27606&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d27606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d27606')) {
      api.createRecord('00d27606', component.options)
    } else {
      api.reload('00d27606', component.options)
    }
    module.hot.accept("./VueInputTag.vue?vue&type=template&id=00d27606&scoped=true", function () {
      api.rerender('00d27606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueInputTag/VueInputTag.vue"
export default component.exports